import { h } from 'preact';
import { RootStore } from '../../js/stores/root.store';
type Props = {
  iconSize: number;
};

export default function ExpandControl({ iconSize }: Props) {
  const isExpanded = RootStore.getInstance().videoStore.isVideoExpanded.value;
  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 466 466"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        {isExpanded ? (
          <g
            transform="translate(54.000000, 54.000000)"
            fill="#FFFFFF"
            fill-rule="nonzero"
          >
            <path
              d="M0,280.5 L76.5,280.5 L76.5,357 L127.5,357 L127.5,229.5 L0,229.5 L0,280.5 Z M76.5,76.5 L0,76.5 L0,127.5 L127.5,127.5 L127.5,0 L76.5,0 L76.5,76.5 Z M229.5,357 L280.5,357 L280.5,280.5 L357,280.5 L357,229.5 L229.5,229.5 L229.5,357 Z M280.5,76.5 L280.5,0 L229.5,0 L229.5,127.5 L357,127.5 L357,76.5 L280.5,76.5 Z"
              id="Shape"
            />
          </g>
        ) : (
          <g
            transform="translate(55.000000, 54.000000)"
            fill="#FFFFFF"
            fill-rule="nonzero"
          >
            <path
              d="M51,229.5 L0,229.5 L0,357 L127.5,357 L127.5,306 L51,306 L51,229.5 Z M0,127.5 L51,127.5 L51,51 L127.5,51 L127.5,0 L0,0 L0,127.5 Z M306,306 L229.5,306 L229.5,357 L357,357 L357,229.5 L306,229.5 L306,306 Z M229.5,0 L229.5,51 L306,51 L306,127.5 L357,127.5 L357,0 L229.5,0 Z"
              id="Shape"
            />
          </g>
        )}
      </g>
    </svg>
  );
}
